'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/IconSvg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var MonthPicker = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(MonthPicker, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(MonthPicker);

  function MonthPicker() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, MonthPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      year: _this.props.year
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handlePreviousClick", function () {
      _this.setState(function (prevState) {
        return {
          year: parseInt(prevState.year, 10) - 1
        };
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleNextClick", function () {
      _this.setState(function (prevState) {
        return {
          year: parseInt(prevState.year, 10) + 1
        };
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "selectMonth", function (e) {
      var month = e.target.innerText;
      var date = new Date("".concat(month, " 01 ").concat(_this.state.year));

      _this.props.onSelect(date);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(MonthPicker, [{
    key: "isSelected",
    value: function isSelected(monthName) {
      return monthName === this.props.selected.toLocaleString('en-us', {
        month: 'short'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var header = /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-mol-month-picker-header"
      }, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "ds-arrow-left",
        onClick: this.handlePreviousClick
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-atom-option-picker-icon dm_icon arrow",
        icon: "arrow"
      })), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-mol-month-picker-year"
      }, this.state.year), /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "ds-arrow-right",
        onClick: this.handleNextClick
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-atom-option-picker-icon dm_icon arrow",
        icon: "arrow"
      })));
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var cells = months.map(function (monthName) {
        return /*#__PURE__*/React__default['default'].createElement("div", {
          className: "ds-mol-month-picker-month ".concat(_this2.isSelected(monthName) ? 'selected' : ''),
          key: monthName
        }, monthName);
      });
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-mol-month-picker-container ".concat(this.props.className)
      }, header, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-mol-month-picker",
        role: "button",
        tabIndex: 0,
        onClick: this.selectMonth,
        onKeyDown: this.selectMonth
      }, cells));
    }
  }]);

  return MonthPicker;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(MonthPicker, "propTypes", {
  className: PropTypes__default['default'].string,
  onSelect: PropTypes__default['default'].func,
  selected: PropTypes__default['default'].instanceOf(Date),
  year: PropTypes__default['default'].number
});

_rollupPluginBabelHelpers.defineProperty(MonthPicker, "defaultProps", {
  className: '',
  onSelect: function onSelect() {},
  selected: new Date(),
  year: new Date().getFullYear()
});

module.exports = MonthPicker;
